import React, { useState } from 'react'
import { Mask } from 'antd-mobile-v5'
import { CLUB_URL_DOMAIN } from '../../utils/env'
import {UClick} from '../common/utils'
import styles from './css/ClubMembershipPopup.module.css'

const ClubMembershipPopup = ({ displayStatus }) => {

  const [visible, setVisible] = useState(displayStatus)

  const pushEvent = (action) => {
    let actionMap = {
      close : "EcardsPopCloseButton",
      leave : "EcardsLeaveButton",
    }
    if(actionMap[action]) {
      UClick(actionMap[action])
    }
  }

  const toClubMemberPage = () => {
    UClick('EcardsRightGet');
    setTimeout(()=>{
      window.location.href = CLUB_URL_DOMAIN + '/pages-mine/mine/member-center'
    },500)
  }

  return <Mask visible={visible} onMaskClick={() => setVisible(false)} className={styles.wrapper}>
    <div className={styles.mask}>
      <div className={styles.popup}>
        <img src={require('../../assets/images/club/popup_bg.png')} alt="popup" className={styles.bg} />
        <img src={require('../../assets/images/club/close.png')} alt="close" className={styles.close} onClick={() => {pushEvent('close');setVisible(false)}} />
        <div className={styles.btns}>
          <input type="image" src={require('../../assets/images/club/leave_btn.png')} className={styles.btn1} onClick={() => {pushEvent('leave');setVisible(false)}} />
          <input type="image" src={require('../../assets/images/club/get_btn.png')} className={styles.btn2} onClick={toClubMemberPage} />
        </div>
      </div>
    </div>
  </Mask>
}

export default ClubMembershipPopup